import { type PropsWithChildren } from 'react';
import { useIsomorphicLayoutEffect } from '@direct-frontend/stdlib';
import { resolveViewportMetaContent, syncViewportMeta } from '../viewport';
import { getPlatformWrapperClassName, syncPlatformDocumentClass } from './platformClass';
import { useEffectivePlatform } from './useEffectivePlatform';
import { getDevicePlatform } from './windowPlatform';

export const MobileRouteSync = ({ children }: PropsWithChildren) => {
    const effectivePlatform = useEffectivePlatform();
    const showMobileView = effectivePlatform === 'mobile';
    const viewportContent = resolveViewportMetaContent({
        devicePlatform: getDevicePlatform(),
        showMobileView,
    });
    const platformClassName = getPlatformWrapperClassName(effectivePlatform);

    // Нужно реагировать на смену роута и viewport, поэтому так
    if (typeof window !== 'undefined') {
        // eslint-disable-next-line react-hooks/immutability -- Необходимо выставить при изменении типа устройства
        globalThis.PLATFORM = effectivePlatform;
        syncViewportMeta(viewportContent);
        syncPlatformDocumentClass(effectivePlatform);
    }

    useIsomorphicLayoutEffect(() => {
        syncViewportMeta(viewportContent);
        syncPlatformDocumentClass(effectivePlatform);
    }, [viewportContent, effectivePlatform]);

    return (
        <div key={effectivePlatform} className={platformClassName} style={{ height: '100%' }}>
            {children}
        </div>
    );
};
